import { EventTracker, TrackingObject } from './event-tracking.service';

declare global {
  interface Window {
    dataLayer: any;
  }
}

function gtag(...args: Array<any>): void {
  window.dataLayer.push(arguments);
}

export class GAEventTracker implements EventTracker
{
  constructor(trackingId, conversionLabels)
  {
    const trackingUrl =
        `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    const gaScript = document.createElement('script');
    gaScript.type = 'text/javascript';
    gaScript.async = true;
    gaScript.src = trackingUrl;

    document.getElementsByTagName('script')[0].parentNode.appendChild(gaScript);

    // https://developers.google.com/analytics/devguides/collection/gtagjs/
    window.dataLayer = window.dataLayer || [];

    gtag('js', new Date());
    gtag('config', trackingId, {
      'linker': {
        'accept_incoming': true,
      },
      'anonymize_ip': true
    });
    for (const conversionLabel of conversionLabels) {
      gtag('config', conversionLabel);
    }
  }

  public send(track: TrackingObject, autoEvent: boolean = false): void
  {
    gtag('event', track.action, {
      'event_category': track.category,
      'event_label': track.label,
      'value': track.value,
      'non_interaction': autoEvent
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/tracking/google-analytics-event-tracker.ts